import { JSX, ReactElement } from 'react';

export enum HeadCellFilterType {
  SORT = 'sort',
  CHECKBOXFILTER = 'checkboxFilter',
  SEARCHFILTER = 'search',
  EMPTY = '',
}

export type ColumnDefinition<T> = {
  id: keyof T;
  label: string | ReactElement;
  filter: HeadCellFilterType;
  filterInputPlaceholder?: string;
  filterInputType?: 'number' | 'text';
  filterValues?: (string | undefined)[];
  mapFilterValues?: (value: string) => string;
  width?: string;
  render?: (row: T, index?: number) => false | undefined | JSX.Element | JSX.Element[] | string | null;
  color?: string;
  backgroundColor?: string;
  shouldFormatEnum?: boolean;
};
